import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import DialogTitle, { type DialogTitleProps } from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import type { DialogProps } from '@mui/material/Dialog';

type DialogCloseReason = Parameters<NonNullable<DialogProps['onClose']>>[1];

/**
 * 입력 폼 Dialog의 onClose를 감싸서 배경 클릭으로는 닫히지 않게 한다.
 * ESC 키(escapeKeyDown)는 그대로 통과시켜 onClose를 호출한다.
 */
export function blockBackdropClose(onClose: () => void) {
  return (_event: unknown, reason: DialogCloseReason) => {
    if (reason === 'backdropClick') return;
    onClose();
  };
}

interface FormDialogTitleProps extends Omit<DialogTitleProps, 'children'> {
  onClose: () => void;
  children: ReactNode;
}

/** 제목 + 우측 상단 닫기(✕) 버튼을 함께 렌더링하는 DialogTitle. */
export function FormDialogTitle({ onClose, children, sx, ...rest }: FormDialogTitleProps) {
  return (
    <DialogTitle
      {...rest}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        ...sx,
      }}
    >
      <Box component="span" sx={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {children}
      </Box>
      <IconButton aria-label="닫기" size="small" onClick={onClose} sx={{ ml: 1, flexShrink: 0 }}>
        ✕
      </IconButton>
    </DialogTitle>
  );
}
